/**
 * 通知的來源站台：顯示名稱與圖示。
 *
 * 通知會從三個站進來（平台、社群、AI），原本鈴鐺和通知中心各自用
 * 「通知類型」決定圖示（訂單一個、佣金一個、公告一個）。改成用**來源站台**
 * 的主圖示，理由是使用者第一眼想知道的是「這是哪個站來的」——
 * 類型從標題就看得出來，站台不標就看不出來。
 *
 * 名稱和圖示放在同一張表：兩者一定要同步，分開放遲早會出現
 * 「圖示是社群、文字寫平台」這種對不起來的狀況。
 */

/** 後端 Notification.SourceSite 的值 → 顯示用的名稱與圖示 */
const SOURCES = {
  lt: {
    name: "小芋頭平台",
    icon: require("@/assets/image/serivceIcon/platform_icon.svg"),
  },
  sms: {
    name: "小芋頭社群網站",
    icon: require("@/assets/image/serivceIcon/sms_icon.svg"),
  },
  aichat: {
    name: "AI勞動法務諮詢",
    icon: require("@/assets/image/ai/金豐ai公版icon.svg"),
  },
};

/**
 * 沒帶 sourceSite、或帶了未知的值，都當成平台。
 *
 * 資料庫裡曾經有 "wt"（工作站）這個值的設計，但後端從來沒有寫入過，
 * 所以不列。真的出現了也會落到這裡顯示成平台，不會壞掉。
 */
const FALLBACK = SOURCES.lt;

export function sourceName(code) {
  return (SOURCES[code] || FALLBACK).name;
}

export function sourceIcon(code) {
  return (SOURCES[code] || FALLBACK).icon;
}
